import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import AppButton from '../components/buttons/AppButton';
import LangSelectBox from '../components/items/LangSelectBox';

import MainView from '../components/views/MainView';
import sha1 from 'js-sha1';

const WelcomeScreen = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    let {loggedIn, preselect, byCardZar} = useSelector(mapStateToProps)   

    return (
        <>
        {loggedIn ?
            <Navigate to="/jidelnicek" replace />
        :
        <MainView>
            {preselect && preselect.zarizeni && <Navigate to="/prihlaseni" replace />}
            {byCardZar && <Navigate to={"/prihlaseni-karta/"+byCardZar+"/"+sha1('karta'+byCardZar)} replace />}
            <div className="baseMarginView">
                <h2 className="wizard_header">{t('welcome.header')}</h2>
                <p className="wizard_text">{t('welcome.text1')}</p>

                <LangSelectBox style={{marginBottom: 12}} />

                <p className="wizard_text">{t('welcome.text2')}</p>
                
                <AppButton style={{marginBottom: 12}} testId="choose-canteen-button" label={t('welcome.choose')} onPress={() => navigate("/vyber-jidelny")}/>

                <p className="wizard_text">{t('welcome.text3')}</p>
            </div>

        </MainView>}
        </>
    )

}

const mapStateToProps = (state) => {
    return {
      loggedIn: state.auth.loggedIn,
      preselect: state.auth.preselect,
      byCardZar: state.auth.byCardZar
    }
  }

export default WelcomeScreen
